import React from 'react'

function RingIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.3424 12.9456C7.72187 10.6688 9.69178 9 12 9V9C14.3082 9 16.2781 10.6688 16.6576 12.9456L16.7605 13.5631C16.9163 14.4976 17.3601 15.3601 18.03 16.03V16.03C18.388 16.388 18.1345 17 17.6283 17H6.37174C5.86553 17 5.61202 16.388 5.96997 16.03V16.03C6.63988 15.3601 7.08373 14.4976 7.23948 13.5631L7.3424 12.9456Z"
        stroke="#393D63"
        stroke-width="2"
      />
      <path
        d="M11 9L12 3"
        stroke="#393D63"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M13 9L12 3"
        stroke="#393D63"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M10.0681 20.6294C10.1821 20.7357 10.4332 20.8297 10.7825 20.8967C11.1318 20.9637 11.5597 21 12 21C12.4403 21 12.8682 20.9637 13.2175 20.8967C13.5668 20.8297 13.8179 20.7357 13.9319 20.6294"
        stroke="#393D63"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  )
}

export default RingIcon
